// Minimal i18n definitions used across the app.
//
// If additional locales are added, extend this list and ensure `getMessages`
// in `src/i18n/messages/` can provide messages for the new locale.

export const locales = ['en', 'vi', 'ar', 'id', 'km', 'th', 'zh'] as const;

export type Locale = (typeof locales)[number];

// Default locale for next-intl routing/config.
export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  vi: 'Tiếng Việt',
  ar: 'العربية',
  id: 'Bahasa Indonesia',
  km: 'ភាសាខ្មែរ',
  th: 'ไทย',
  zh: '中文',
};
